<div *ngIf="!isLoading" class="section" style="flex: 1; display: flex; flex-direction: column;" data-cy="insurance-no-fee-schedule-container">

  <div class="section-header" data-cy="insurance-no-fee-schedule-header">
    <div class="section-header-title" data-cy="insurance-no-fee-schedule-title">No Fee Schedule Found</div>
  </div>
  <div class="section-content" style="display: flex; flex-direction: column; flex: 1;" *ngIf="!isLoading" data-cy="insurance-no-fee-schedule-content">

    <div style="height: 275px; width: 600px" data-cy="insurance-no-fee-schedule-message-container">
      <div style="padding-bottom: 15px" data-cy="insurance-no-fee-schedule-warning-icon-container">
        <mat-icon style="font-size: 60px; color: orange; line-height: normal !important;" inline="inline" data-cy="insurance-no-fee-schedule-warning-icon">warning</mat-icon>
      </div>
      <span data-cy="insurance-no-fee-schedule-org-message">The organization <b data-cy="insurance-no-fee-schedule-org-name">{{ organizationName }}</b> does not have a fee schedule.</span>
      <div style="padding-top: 15px; padding-bottom: 15px" data-cy="insurance-no-fee-schedule-instructions">
        If this is a mistake, please go to Settings / Fee Schedules and create all needed fee schedules needed
        for this organization before proceeding.
      </div>
      <div data-cy="insurance-no-fee-schedule-alternative">Alternatively, would you like to use the Default Fee Schedule/UCR for this organization from now on?</div>

<!--      Please go to Settings/Practice Information/Fee schedules"  and create one if applicable!-->
    </div>

    <div class="action-container" style="text-align: right" data-cy="insurance-no-fee-schedule-actions">
      <button class="tdo-button tdo-save" style="margin-right: 12px;" (click)="selectUCR()" data-cy="insurance-no-fee-schedule-ucr-button">Use UCR</button>
      <button class="tdo-button tdo-close" (click)="cancel()" data-cy="insurance-no-fee-schedule-cancel-button">Cancel</button>

    </div>

  </div>
</div>

<app-tdo-progress-spinner *ngIf="isLoading" data-cy="insurance-no-fee-schedule-loading"></app-tdo-progress-spinner>





